module.exports = __webpack_public_path__ + "img/cg.994a4cc7.svg";